import styled from 'styled-components';

export const StyledEmptyKpiCard = styled.div`
  padding: 0 10px;
  color: ${({ theme }) => theme.black};
  h2 {
    text-align: center;
    font-weight: bold;
  }
  p {
    font-size: 14px;
    text-align: center
  }
`;

export const StyledLoadContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
